import React from 'react';
import {FormattedMessage} from "react-intl";

import {black400, black500} from "assets/jss/main";

function NoOrganizationFound(props) {
    return (
        <div style={{
            fontSize: '14px',
            textAlign: 'center',
            padding: '10px 8px',
        }}>
            <div style={{
                fontWeight: 600,
                color: black500,
                marginBottom: '16px',
            }}>
                 <FormattedMessage id='sidebar.organization.menu.notFound' />
            </div>

            <div style={{
                color: black400
            }}>
                <FormattedMessage id='sidebar.organization.menu.notFound.sub' />
            </div>
        </div>
    );
}

export default NoOrganizationFound;
